import { gsap, Elastic, Bounce, Power1 } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded',function() {
    gsap.registerPlugin(ScrollTrigger);
    
    window.anims = () => {   
        gsap.utils.toArray(".js-fadeInChildren > *").forEach(function(section) {
            gsap.from(section, {
                scrollTrigger: {
                    trigger: section,
                    start: '-50px bottom',
                    toggleActions: "play complete complete reset",
                },
                opacity: 0, 
                duration: 1,
                y: 50
            });
        });   
        
        if (document.querySelector('.c-cloud')) {  
            let i = 0, path;
            
            ScrollTrigger.matchMedia({
                "(min-width: 769px)": function() {
                    path = document.querySelectorAll('.c-cloud__desktop path');

                    ScrollTrigger.batch(".c-cloud__desktop", {
                        onEnter: elements => {
                            gsap.from(path, {
                                autoAlpha: 0,
                                scale: 2,
                                stagger: {
                                    each: .02,
                                    onComplete: function() {
                                        gsap.to(path[i], {
                                            opacity: .4,
                                            scale: .94,
                                            duration: Math.random(3)+1,
                                            repeat: -1, yoyo: true,
                                            ease: Power1.easeInOut
                                        })
                                        i++; 
                                    }
                                },
                                duration: 2,
                                transformOrigin:"50% 50%",
                                ease: 'elastic.out(.4, .8)',
                            });
                        },
                        once: 1
                    }); 
/*
                    ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".c-cloud__desktop path", {
                        utoAlpha: 0,
                        scale: 1,
                    }));
*/
                },
                
                "(max-width: 768px)": function() {
                    path = document.querySelectorAll('.c-cloud__mobile path');
                    
                    ScrollTrigger.batch(".c-cloud__mobile", {
                        onEnter: elements => {
                            gsap.from(path, {
                                autoAlpha: 0,
                                scale: 2,
                                stagger: {
                                    each: .02,
                                    onComplete: function() {
                                        gsap.to(path[i], {
                                            opacity: .4,
                                            scale: .94,
                                            duration: Math.random(3)+1,
                                            repeat: -1, yoyo: true,
                                            ease: Power1.easeInOut
                                        })
                                        i++; 
                                    }
                                },
                                duration: 2,
                                transformOrigin:"50% 50%",
                                ease: 'elastic.out(.4, .8)',
                            });
                        },
                        once: 1
                    });   
                }
            })          
        };
        
        if (document.querySelector('.c-findplace')) {
            const tl = gsap.timeline().delay(1).
                from('.c-findplace .o-dots--01', 1, { 
                    autoAlpha: 0,
                    yPercent: -50,
                    ease: 'elastic.out(1, .8)',
                }).
                from('.c-findplace .o-dots--02', 1, { 
                    autoAlpha: 0,
                    xPercent: 20,
                    ease: 'elastic.out(1, .8)',
                }, '-=.5')
                
            gsap.to('.c-findplace .o-dots--01', {
                scrollTrigger: { trigger: '.c-findplace', scrub: 1, start: 'top center' }, y: -100
            });
            
            gsap.to('.c-findplace .o-dots--02', {
                scrollTrigger: { trigger: '.c-findplace', scrub: 1, start: 'top center' }, x: 200
            });
        }
        
        if (document.querySelector('.c-hero')) {
            const tl = gsap.timeline().delay(1).
                from('.c-hero .o-dots--01', 1, { 
                    autoAlpha: 0,
                    xPercent: -50,
                    ease: 'elastic.out(1, .8)',
                }).
                from('.c-hero .o-dots--02', 1, { 
                    autoAlpha: 0,
                    yPercent: -50,
                    ease: 'elastic.out(1, .8)',
                }, '-=.5')
        }
        
        if (document.querySelector('.c-practice')) {
            gsap.from('.c-practice .swiper', {
                scrollTrigger: {
                    trigger: '.c-practice .swiper',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center',
                },      
                xPercent: -15
            });
            
            gsap.to('.c-practice .o-dots--01', {
                scrollTrigger: { trigger: '.c-practice', scrub: 1 }, y: 50
            });
            
            gsap.from('.c-practice .o-dots--02', {
                scrollTrigger: { trigger: '.c-practice', scrub: 1 }, x: 100
            });
        }
        
        if (document.querySelector('.c-reviews')) {
            gsap.from('.c-reviews .swiper', {
                scrollTrigger: {
                    trigger: '.c-reviews .swiper',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center',
                },      
                xPercent: 15
            });
            
            gsap.from('.c-reviews .o-dots--01', {
                scrollTrigger: { trigger: '.c-reviews', scrub: 1 }, y: -100
            });
            
            gsap.from('.c-reviews .o-dots--02', {
                scrollTrigger: { trigger: '.c-reviews', scrub: 1 }, x: -100
            });
        }    
        
        if (document.querySelector('.c-teams')) {
            gsap.from('.c-teams .o-dots--01', {
                scrollTrigger: { trigger: '.c-teams', scrub: 1 }, y: -100
            });
        }
    };

    window.addEventListener('load', function() {
        
        setTimeout(() => {
            ScrollTrigger.refresh();            
        }, 2000)
    })

}, false)
